import { loadShared } from './dashboardCache';

// What a click on the Tutor Replacement Count pages opens: the replacements behind a number (see tutor_replacement_details.controller.js
// on the server).
//   a CRO's count (or one of its three reason columns)   -> that CRO's replacements   { croId, reason? }
//   a replaced tutor's count (or a reason column)         -> that tutor's replacements { tutorId, reason? }
// One place builds the URL, so the page that PREFETCHES on hover and the popup that LOADS on click share the very same remembered
// answer (dashboardCache.js).
export const REASON_LABEL = { tutor: 'Tutor-related', parent: 'Parent-related', other: 'Other' };

export const replacementsUrl = ({ croId, tutorId, reason, month }) => {
  const params = new URLSearchParams();
  if (croId !== undefined && croId !== null) params.set('croId', String(croId));
  if (tutorId !== undefined && tutorId !== null) params.set('tutorId', String(tutorId));
  if (reason) params.set('reason', reason);
  params.set('month', month.format('YYYY-MM-DD'));
  return `warning-dashboard/tutor-replacement-details?${params.toString()}`;
};

// Warm the remembered answer (no UI): called when the pointer rests on a count, so by the click it is usually there.
export const prefetchReplacements = (url) => {
  loadShared(url).catch(() => {});
};
